import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Suscriptions } from 'src/app/interfaces/suscription.interface';
import { LoginService } from 'src/app/service/login.service';
import { MessagesService } from 'src/app/service/messages.service';
import { SuscriptionService } from 'src/app/service/suscription.service';

@Component({
  selector: 'app-moredevcomp',
  templateUrl: './moredevcomp.component.html',
  styleUrls: ['./moredevcomp.component.scss'],
  providers: [MessageService], 
})
export class MoredevcompComponent implements OnInit {
  device: Suscriptions[] = [];
  deviceSelected!: Suscriptions;
  idCustomer!: number;
  esAdmin!: boolean;

  @Output() eModal: EventEmitter<any> = new EventEmitter();
  @Output() rModal: EventEmitter<any> = new EventEmitter();

  constructor(private messagesservice: MessagesService, private loginservice: LoginService,
     private suscriptionService: SuscriptionService, private messageService: MessageService) {
      this.idCustomer = loginservice.chatCrmUser.idCustomer;
      this.esAdmin = loginservice.chatCrmUser.idRol === 1;

       suscriptionService.dispositivos().subscribe(data => {
        if(!data.conectado){
          this.messageService.add({
            severity: 'info',
            summary: 'Advertencia',
            detail: 'Hubo cambios en los dispositivos!',
          });
        }
        console.log(this.device)
        this.device = data.dispositivo;
        if(this.device.length === 0){
          this.messageService.add({
            severity: 'info',
            summary: 'Advertencia',
            detail: 'Ningun dispositivo esta activo',
          });
        }
        const deviceSearch = this.deviceSelected != undefined && this.deviceSelected != null ? 
                            this.device.find( d =>d.id==this.deviceSelected.id) : null;
        if(deviceSearch == undefined || deviceSearch == null){
          this.messagesservice.setDispositivo(null);
        }
      })
  }

  ngOnInit(): void {
    this.suscriptionService.catalogoSuscripciones(this.loginservice.chatCrmUser.id, 
      this.loginservice.chatCrmUser.idRol, true).then(result => {
          this.device = result.data;
          this.deviceSelected = this.messagesservice.dispositivoValue;
          this.device.forEach(d => {
            d.checked = this.isChecked(d.id);
          });
      })
  }
  sendCEM() {
    //this.eModal.emit(false);
  }
  sendCRM() {
    this.rModal.emit(false);
  }

  activarNumero(device: Suscriptions) {
    this.messagesservice.setDispositivo(device);
    this.messagesservice.setSelectedChat(null);
    this.messagesservice.infoContacto(null);
  }

  private isChecked(id: any){
    const result = this.deviceSelected == undefined || this. deviceSelected == null ? 
    false : this.deviceSelected.id === id;
    return result
  }
}
